export const GET_CATALOGUES = "GET_CATALOGUES";
export const GET_CATALOGUES_SUCCESS = "GET_CATALOGUES_SUCCESS";
export const GET_CATALOGUES_ERROR = "GET_CATALOGUES_ERROR";
export const GET_CATALOGUES_CLEAR_DATA = "GET_CATALOGUES_CLEAR_DATA";
